import { FormattedMessage as FM } from "react-intl";

import { ArrowRightIcon } from "components/Icons";

function HomeCard({ card, count, onOpen }) {
  const { label, hint, view, Icon } = card;
  return (
    <button
      type="button"
      onClick={() => onOpen(view)}
      className="group flex flex-col gap-3 rounded-lg border border-neutral-200 bg-white p-4 text-left shadow-sm transition hover:border-sky-900 hover:shadow-md"
    >
      <span className="flex items-center justify-between gap-3">
        <span className="flex size-11 shrink-0 items-center justify-center rounded-full bg-sky-950 text-white">
          <Icon width={20} className="fill-current" />
        </span>
        <span className="text-3xl font-semibold text-neutral-800">
          {count ?? "-"}
        </span>
      </span>
      <span className="flex items-end justify-between gap-3">
        <span className="flex min-w-0 flex-col gap-0.5">
          <span className="font-medium text-neutral-800">
            <FM id={label} />
          </span>
          <span className="text-sm text-neutral-500">
            <FM id={hint} />
          </span>
        </span>
        <ArrowRightIcon
          width={20}
          className="shrink-0 fill-neutral-400 transition group-hover:fill-sky-900"
        />
      </span>
    </button>
  );
}

export default HomeCard;
